export class Language {
  public id: number;
  public name: string;
  public locale: string;
}
